module.exports = require('./dist/md-expansion-panel'); 



//////////////////
// WEBPACK FOOTER
// ./~/angular-material-expansion-panel/index.js
// module id = 459
// module chunks = 1